export default "__VITE_ASSET__0802b077__"